(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mobx"), require("antd"), require("ecCom"), require("React"), require("ReactDOM"), require("loadjs"));
	else if(typeof define === 'function' && define.amd)
		define(["mobx", "antd", "ecCom", "React", "ReactDOM", "loadjs"], factory);
	else if(typeof exports === 'object')
		exports["comsMobx"] = factory(require("mobx"), require("antd"), require("ecCom"), require("React"), require("ReactDOM"), require("loadjs"));
	else
		root["comsMobx"] = factory(root["mobx"], root["antd"], root["ecCom"], root["React"], root["ReactDOM"], root["loadjs"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_18__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_226__, __WEBPACK_EXTERNAL_MODULE_202__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition